import { PRODUCT_ACTION_IDS, PRODUCT_ATTRIBUTE_IDS } from "../../../shared/constants/productAttributes";

export const DATA_ITEMS_IDS = {
	ACTIONS:        PRODUCT_ATTRIBUTE_IDS.ACTIONS,
	AREA:           PRODUCT_ATTRIBUTE_IDS.AREA,
	BUILDING:       PRODUCT_ATTRIBUTE_IDS.BUILDING,
	GATE:           PRODUCT_ATTRIBUTE_IDS.GATE,
	ID_CAD:         PRODUCT_ATTRIBUTE_IDS.ID_CAD,
	INQUIRY:        PRODUCT_ATTRIBUTE_IDS.INQUIRY,
	PRICE:          PRODUCT_ATTRIBUTE_IDS.PRICE,
	ROOMS:          PRODUCT_ATTRIBUTE_IDS.ROOMS,
	STATUS:         PRODUCT_ATTRIBUTE_IDS.STATUS,
	TIERS:          PRODUCT_ATTRIBUTE_IDS.TIERS,
    //INSOLATION:			'insolation',
	//COMPARE_AREA:		'compare_area',
    //EXTERNAL_AREAS:    'external_areas',
    //EXPOSITION:        'exposition',
    //ADDITIONAL_AREAS:     'additional_areas',
    //SPECIAL_AREAS:     'special_areas',
    //INSOLATION:        'insolation',
    //EXPOSITION_SIDES:  'exposition_sides',
    //CATEGORY:          'category',
};

export const ACTION_IDS = {
    FAVORITES:      PRODUCT_ACTION_IDS.FAVORITES,
    FLOOR_PLAN:     PRODUCT_ACTION_IDS.FLOOR_PLAN,
	INQUIRY:		PRODUCT_ACTION_IDS.INQUIRY
};